import { call } from 'redux-saga/effects';
import { APIHandler } from '../commonHandlers';

function* getReports(api, action) {
  yield call(APIHandler, api, action);
}

function* getUserHealthReportById(api, action) {
  yield call(APIHandler, api, action);
}

function* getUserLocationReportById(api, action) {
  yield call(APIHandler, api, action);
}
function* getUserContactReportById(api, action) {
  yield call(APIHandler, api, action);
}
export default {
  getReports,
  getUserHealthReportById,
  getUserLocationReportById,
  getUserContactReportById
};
